import { Weapon } from '../../Weapon.js';
import { FUSED_WEAPONS } from '../../../../../config/constants.js';

/**
 * Lumen Lance (Harmonics fusion: Umbral Lantern + Spirit Lance) — the
 * lantern's light thrown, instead of held.
 *
 * A piercing bolt on Spirit Lance's shape, but the wielder keeps a lit disc
 * (`lightRadius`, read by Game._drawGloaming) the whole time. It's the
 * ranged answer to the Lantern's one real cost: the Lantern makes you fight a
 * darkness boss at arm's length to see; the Lance lets you see from anywhere.
 * Smaller light than the Lantern's own — the reach is the trade.
 */
export class LumenLance extends Weapon {
  constructor() {
    super(FUSED_WEAPONS.lumenLance);
  }

  /** How far the wielder lights the dark (see Game._drawGloaming). */
  get lightRadius() {
    return this.config.lightRadius + this.level * 4;
  }

  fire(origin, target, pool) {
    if (!target) return;
    const angle = Math.atan2(target.y - origin.y, target.x - origin.x);
    pool.fire({
      x: origin.x,
      y: origin.y,
      vx: Math.cos(angle) * this.config.projectileSpeed,
      vy: Math.sin(angle) * this.config.projectileSpeed,
      radius: this.config.projectileRadius,
      damage: this.config.damage + this.level * this.config.damagePerLevel,
      hits: this.config.pierce,
      hitCooldownDuration: 0.15,
      lifetime: this.config.lifetime,
      color: this.config.color,
    });
  }
}
